/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2019-09-24 15:29:21
 */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './p23.css';

import ExportHeadTitle from '../../../components/ExportHeadTitle/ExportHeadTitle';
import ExportDes from '../../../components/ExportDes/ExportDes';
import ExportFootDes from '../../../components/ExportFootDes/ExportFootDes';
import ExportEcharts from '../../../components/ExportEcharts/ExportEcharts';
import ExportTable from '../../../components/ExportTable';

import {getBrandDetail} from '../../../controller';
import {shareOfMindSingle} from '../../../chart';
import { getSessionQuery, toThousands } from '../../../utils';
import moment from 'moment';

class P23 extends React.Component {
  constructor () {
    super();

    this.state = {
      query: {
        brandNames: '',
        startDate: '',
        statisDate: ''
      },
      summary: {
        dbRatio: ''
      },
      list: [],
      prevChart: {},
      chart: {}
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount () {
    this.getData();
  }

  getQuery () {
    const query = getSessionQuery('query');
    const result = {
      brandNames: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime
    }
    if (query.isCustom === '1') {
      result.areaIndustry = query.industry
      result.competingBrands = query.competingGoods.map(item => item.value).join(',')
    }
    return result
  }

  getData () {
    const query = this.getQuery();

    getBrandDetail(Object.assign({report: true}, query))
      .then(res => {
        const [...data] = res;
        const newList = data.pop();
        const list = data;
        this.setState({
          query: query,
          summary: {
            dbRatio: newList.dbRatio
          },
          list: list,
          prevChart: shareOfMindSingle(newList.startData, Object.assign({}, query, {
            title: true,
            tooltip: true,
            graphic: true,
            legend: true,
            toolbox: true,
            center: ['65%', '50%'],
            time: moment(query.startDate).format('M月D日') + '数据'
          })),
          chart: shareOfMindSingle(list, Object.assign({}, query, {
            timeLeft: '43%',
            time: moment(query.statisDate).format('M月D日') + '数据'
          }))
        })
      })
  }

  render() {
    const {query, summary, list} = this.state;
    const column = [
      {name: '品牌名称', key: 'name'},
      {name: '排名', key: 'ranking'},
      {name: 'DB值', key: 'db'},
      {name: '日涨跌幅', key: 'daily'},
      {name: '传播度', key: 'spread'},
      {name: '参与度', key: 'participate'},
      {name: '好感度', key: 'favorability'},
      // {name: '心智占有率', key: 'areaMind'}
    ]
    return (
      <div className={s.container}>
        <ExportHeadTitle>心智占有率 – 重点竞品对比</ExportHeadTitle>

        <div style={{
          paddingTop: list.length > 4 ? '10px' : '0'
        }}>
          <ExportDes> 
            本周报告期末（{moment(query.statisDate).format('M月D日')}）与报告期初（{moment(query.startDate).format('M月D日')}）比，
            {query.brandNames}对竞品的心智占有率{summary.dbRatio}。 </ExportDes>
        </div>
        <div>
          <ExportTable
            hasClass='lineTable'
            column={column}
            list={list.map(item => ({
            name: item.name,
            ranking: item.ranking,
            db: toThousands(item.db),
            daily: item.daily,
            spread: item.spread,
            participate: item.participate,
            favorability: item.favorability,
            areaMind: item.areaMind
          }))}></ExportTable>
        </div>
        <div className={s.echartWrapper}>
          <div className={s.left}>
            <ExportEcharts option={this.state.prevChart}></ExportEcharts>
          </div>
          <div className={s.right}>
            <ExportEcharts option={this.state.chart}></ExportEcharts>
          </div>
        </div>

        <ExportFootDes
          brandName={query.brandNames}
          beginTime={query.startDate}
          endTime={query.statisDate}>
        </ExportFootDes>
      </div>
    );
  }
}

export default withStyles(s)(P23);



// WEBPACK FOOTER //
// src/routes/exportPDF/p23/p23.js